import styled from 'styled-components';
import { ReactComponent as DropdownArrows } from '../../icons/dropdownarrows.svg'; // Import as a URL
import { colors } from '../../utils/colors'
import { fontFamily, purpleColors, slateColors } from '../ContentPages/AppLandingPage/styles';


interface DropdownProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
    children: React.ReactNode;
  }

// Base Button with common styles
const BaseDropdown = styled.div`
  position: relative; /* Positioning context for the arrow */
  display: inline-block;

  select {
    font-family: ${fontFamily};
    display: inline-flex;
    padding: 0.65rem 2rem 0.65rem 1rem;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    border-radius: 0.75rem;
    border: 2px solid ${slateColors[200]};
    background: ${slateColors[50]};
    color: ${slateColors[700]};
    position: relative;
    max-width: 100%; /* Ensure the dropdown does not exceed its container's width */
    width: 100%; /* Take full width of the parent container */
    transition: all 0.2s;

    -webkit-appearance: none; /* Remove default arrow on Safari and Chrome */
    appearance: none; /* Remove default arrow on other browsers */
    -webkit-tap-highlight-color: transparent;

    /* Ellipsis text overflow handling */
    white-space: nowrap; /* Prevent text from wrapping */
    overflow: hidden; /* Hide overflowing text */
    text-overflow: ellipsis; /* Show ellipsis for overflow text */

    &:hover {
      background: ${slateColors[100]};
      border-color: ${purpleColors[300]};
      color: ${slateColors[900]};
    }

    &:active {
      background: ${slateColors[200]};
      border-color: ${purpleColors[400]};
    }

    &:focus {
      outline: none;
      border-color: ${purpleColors[500]};
      box-shadow: 0 0 0 3px ${purpleColors[100]};
    }

    &:disabled {
      background: ${slateColors[50]};
      border: 2px solid ${slateColors[200]};
      color: ${slateColors[400]};
      cursor: not-allowed;
    }

    /* Adjust padding to make room for the custom arrow */
    padding-right: 2.5rem;
  }

  svg {
    position: absolute;
    right: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  svg path {
    fill: ${slateColors[600]};
    transition: fill 0.2s;
  }

  &:hover svg path {
    fill: ${slateColors[900]};
  }
`;

// Small Dropdown with specific font size
const BaseDropdownS = styled(BaseDropdown)`
  select {
    font-size: 16px;
  }
`;

// Medium Dropdown with specific font size
const BaseDropdownM = styled(BaseDropdown)`
  select {
    font-size: 24px;
  }
`;



export const DropdownS: React.FC<DropdownProps> = ({ children, ...props }) => (
    <BaseDropdownS>
      <select {...props}>
        {children}
      </select>
      <DropdownArrows width={8} height={12} />
    </BaseDropdownS>
  );
  
  export const DropdownM: React.FC<DropdownProps> = ({ children, ...props }) => (
    <BaseDropdownM>
      <select {...props}>
        {children}
      </select>
      <DropdownArrows width={12} height={16} />
    </BaseDropdownM>
  );